import Link from 'next/link';

import ArrowRightIcon from '@/fo/icons/base/landing/right-bioderma-link.svg';
import { UiKitCarouselBase } from '@/fo/ui/kit/carousel/base';
import {
  Product,
  UiLandingProductCardBioderma
} from '@/fo/ui/landing/product-card/bioderma';
import { staticMediaUrl } from '@/fo/util/image-loader';
import { addLandingProductToCart } from '@/fo/util/landing-prices';
import { reachMetrikaGoal } from '@/fo/util/metrics';

import { styles } from './OtherProducts.styles';

export interface OtherProductsProps {
  products: Product[];
}

const catalogHref = '/catalog/bioderma/gammy/hydrabio/';

/** Слайдер остальных средств гаммы */
export function OtherProducts({ products }: OtherProductsProps) {
  const slots = styles();

  const onCatalogClick = () => {
    reachMetrikaGoal('perehod_v_kategoriu_kataloga');
  };

  return (
    <section
      id="other-products"
      className={slots.base()}
    >
      <div className={slots.banner()}>
        <div className={slots.content()}>
          <h2 className={slots.title()}>
            Попробуйте другие средства гаммы HYDRABIO
          </h2>
          <Link
            href={catalogHref}
            target="_blank"
            className={slots.link()}
            onClick={onCatalogClick}
          >
            Все средства гаммы
            <ArrowRightIcon className="[&_path]:stroke-current" />
          </Link>
        </div>
        <picture>
          <source
            srcSet={staticMediaUrl(
              'landing/bioderma-hydrabio/other-products/mobile.webp'
            )}
            media="(max-width: 767px)"
          />
          <img
            className={slots.bg()}
            src={staticMediaUrl(
              'landing/bioderma-hydrabio/other-products/desktop.webp'
            )}
            alt=""
          />
        </picture>
      </div>
      <UiKitCarouselBase
        className={slots.products()}
        arrowPrevClass={slots.arrowPrev()}
        arrowNextClass={slots.arrowNext()}
        alwaysShowArrows
        loop={false}
      >
        {products.map((product, index) => (
          <UiLandingProductCardBioderma
            key={product.sku}
            className="!w-full !min-w-0 text-black"
            classNameImageWrapper="!h-auto !w-full [&_img]:!h-auto [&_img]:!w-full [&_img]:object-contain"
            product={product}
            positionIndex={index}
            onAddToCart={() => addLandingProductToCart(product)}
          />
        ))}
      </UiKitCarouselBase>
      <Link
        href={catalogHref}
        target="_blank"
        className={slots.button()}
        onClick={onCatalogClick}
      >
        Все средства гаммы
      </Link>
    </section>
  );
}
